import { render, staticRenderFns } from "./NoticeReg.vue?vue&type=template&id=406d793b&scoped=true"
import script from "./NoticeReg.vue?vue&type=script&lang=js"
export * from "./NoticeReg.vue?vue&type=script&lang=js"
import style0 from "./NoticeReg.vue?vue&type=style&index=0&id=406d793b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d793b",
  null
  
)

export default component.exports